<template>
	<Component
		:is="isSpan ? 'span' : 'p'"
		class="amelipro-badge"
		:class="roundedRight ? 'round-custom' : 'round-classic'"
		:style="style"
	>
		<span
			class="amelipro-badge__content"
			:style="styleText"
		>
			{{ badgeContent }}
		</span>
	</Component>
</template>

<script setup lang="ts">
	import { IndexedObject } from '../../types';
	import { computed } from 'vue';
	import { convertToHex } from '../../functions/convertToHex';

	const props = defineProps({
		badgeColor: {
			type: String,
			default: 'ap-blue darken-1',
		},
		badgeContent: {
			type: String,
			default: undefined,
		},
		badgeTextColor: {
			type: String,
			default: 'ap-white',
		},
		isSpan: {
			type: Boolean,
			default: false,
		},
		roundedRight: {
			type: Boolean,
			default: false,
		},
	});

	const style = computed<IndexedObject>(() => ({ backgroundColor: convertToHex(props.badgeColor) }));
	const styleText = computed<IndexedObject>(() => ({ color: convertToHex(props.badgeTextColor) }));
</script>

<style lang="scss" scoped>
.amelipro-badge {
	margin-left: 0.5rem;
	padding: 0.5rem 1rem !important;

	&.round-custom {
		border-radius: 0.5rem 1rem 1rem 0.5rem;
	}

	&.round-classic {
		border-radius: 1rem;
	}
}

.amelipro-badge__content {
	display: block;
	font-size: $font-size-sm !important;
	font-weight: $ap-font-weight-semi-bold !important;
}
</style>
